export default __webpack_public_path__ + "static/cover_en-7653745566e930add7649107df6e6ff7.png";